export const roleDashboards = {
  section: 'Role dashboards',
  organisation: 'Organisation dashboard',
  organisationYours: 'Your organisation dashboard',
  moderator: 'Moderator dashboard',
  moderatorYours: 'Your moderator dashboard',
  facilitator: 'Facilitator dashboard',
  facilitatorYours: 'Your facilitator dashboard',
  wanderWriter: 'Wander writer dashboard',
  wanderWriterYours: 'Your wander writer dashboard',
  author: 'Artist dashboard',
  authorYours: 'Your artist dashboard',
  participant: 'Participant dashboard',
  participantYours: 'Your participant dashboard',
  organisationViewYours: 'View your organisation dashboard',
  moderatorViewYours: 'View your moderator dashboard',
  facilitatorViewYours: 'View your facilitator dashboard',
  wanderWriterViewYours: 'View your wander writer dashboard',
  authorViewYours: 'View your artist dashboard',
  participantViewYours: 'View your participant dashboard',
  organisationPreview: 'Preview the organisation admin dashboard',
  moderatorPreview: 'Preview the moderator dashboard',
  facilitatorPreview: 'Preview the facilitator dashboard',
  wanderWriterPreview: 'Preview the wander writer dashboard',
  authorPreview: 'Preview the artist / author dashboard',
  participantPreview: 'Preview the workshop participant dashboard',
}
